import FraudIndicatorsContent from './FraudIndicatorsContent'

export default FraudIndicatorsContent
